/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Leavedraftkeptbody3Inputs */

const en_leavedraftkeptbody3 = /** @type {(inputs: Leavedraftkeptbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your draft stays saved on this device. You find it again under Create event.`)
};

const de_leavedraftkeptbody3 = /** @type {(inputs: Leavedraftkeptbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dein Entwurf bleibt auf diesem Gerät gespeichert. Du findest ihn wieder unter Event erstellen.`)
};

/**
* | output |
* | --- |
* | "Your draft stays saved on this device. You find it again under Create event." |
*
* @param {Leavedraftkeptbody3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const leavedraftkeptbody3 = /** @type {((inputs?: Leavedraftkeptbody3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Leavedraftkeptbody3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_leavedraftkeptbody3(inputs)
	return de_leavedraftkeptbody3(inputs)
});
export { leavedraftkeptbody3 as "leaveDraftKeptBody" }